module.exports = __webpack_public_path__ + "img/Fond-tarifs1 - Copie.50fce62a.jpg";